import UserHomePage from '../components/user-home';
import { UserHomeDataProvider } from '../providers/user-home-provider';

export default function HomePage() {
    return (<>
        <UserHomeDataProvider>
            <UserHomePage />
        </UserHomeDataProvider>
    </>);
};